import { useEffect, useRef, useState } from "react";

import { countryCallingCodes, Validation, searchCountry } from "../../helper/function";
import axiosInstance from "../../helper/AxiosInstance";
import { toast } from "react-toastify";
export const RequestForFreeTrial = () => {
    const closemodel = useRef(null)
    const [request, setRequest] = useState({ otpLoader: false, otpSend: false, reqLoader: false, reSend: 0 })
    const [countrys, setCountrys] = useState(countryCallingCodes)
    const [industries, setIndustries] = useState([])
    const empty = { firstName: '', lastName: '', email: '', mobile: '', organization: '', industryID: '', searchCountry: '', countryCode: '+91', country: 'India', otp: "" }
    const [data, setData] = useState(empty);
    const ChangeInput = (event) => {
        Validation(event)
        const target = event.currentTarget;
        setData((prev) => ({ ...prev, [target.name]: target.value }))
    }
    const SendRequestOTP = async (event) => {
        try {
            setRequest((prev) => ({ ...prev, otpLoader: true }))
            const response = await axiosInstance.post('/public/request-fro-free-trial-otp', data)
            if (response.status == 1) {
                setRequest((prev) => ({ ...prev, otpSend: true, reSend: 120 }))
                toast.success(response.message, { autoClose: 700, position: 'top-center' })
            } else {
                toast.warn(response.message, { autoClose: 700, position: 'top-center' })
            }
        } catch (err) {
            toast.error(err.message, { autoClose: 700, position: 'top-center' })
        } finally {
            setRequest((prev) => ({ ...prev, otpLoader: false }))
        }

    }
    const SendRequest = async (event) => {
        event.preventDefault()
        try {
            setRequest((prev) => ({ ...prev, reqLoader: true }))
            const response = await axiosInstance.post('/public/request-fro-free-trial', data)
            if (response.status == 1) {
                closemodel.current.click(); setData((prev) => ({ ...prev, ...empty, otp: "" }))
                toast.success(response.message, { position: 'top-center' })
            } else {
                toast.warn(response.message, { autoClose: 700, position: 'top-center' })
            }
        } catch (err) {
            toast.error(err.message, { autoClose: 700, position: 'top-center' })
        } finally {
            setRequest((prev) => ({ ...prev, reqLoader: false }))
        }

    }
    const fetchIndustries = async () => {
        try {
            const res = await axiosInstance.get('/public/industries');
            if (res.status === "success") { setIndustries(res.data) }
        } catch (error) { }
    }
    useEffect(() => {
        setCountrys(countryCallingCodes.filter(cty => cty.name.toLowerCase().includes(data.searchCountry.toLowerCase()) || cty.code.toLowerCase().includes(data.searchCountry.toLowerCase())))
    }, [data.searchCountry])
    useEffect(() => {
        fetchIndustries()
    }, [])
    useEffect(() => {
        if (request.reSend <= 0) return;
        const interval = setInterval(() => {
            setRequest(prev => ({ ...prev, reSend: prev.reSend - 1 }));
        }, 1000);
        return () => clearInterval(interval);
    }, [request.reSend]);
    return (<>
        <div className="modal fade modal-contact-popup-one" id="request-for-free-trial" tabIndex={-1} role="dialog" aria-labelledby="contactModalTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <main className="main-body modal-content clearfix">
                    <button type="button" className="close btnmodl" data-bs-dismiss="modal" aria-bs-label="close" onClick={() => { setData((prev) => ({ ...prev, ...empty })); setRequest((prev) => ({ ...prev, otpSend: false })) }} ref={closemodel}>
                        <img src="/main/images/icon/close.svg" alt="" />
                    </button>
                    <div className="headpopup">
                        <p className="form-pre">Safe &amp; Confidential</p>
                        <h2 className="form-title">Request For Free 3-Day Trial</h2>
                    </div>
                    <div className="right-side">
                        {
                            request.otpSend ?
                                <form className="submitrequest" onSubmit={SendRequest}>
                                    <div className="row controls">
                                        <div class="col-md-12 col-12 mb-2">
                                            <div className="input-group-meta form-group">
                                                <label>Enter  OTP <span class="text-danger">*</span></label>
                                                <input name="otp" type="text" class="form-control" placeholder="Enter OTP received your mail id" id="name" data-type="numeric" maxLength="6" value={data.otp} onInput={ChangeInput} required />
                                                {request.otpLoader ? <small className="text-primary">sending...</small> : request.reSend ? <small className="text-muted">Resend OTP in {parseInt(request.reSend / 60).toString().padStart(2, '0')}:{(request.reSend % 60).toString().padStart(2, '0')} min</small> : <small className="text-primary" onClick={() => SendRequestOTP()}>Resend</small>}
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            {request.reqLoader ? <button type="button" className="theme-btn-seven w-100" disabled><div class="spinner-border" role="status" style={{ width: "17px", height: "17px" }}></div></button> : <button type="submit" className="theme-btn-seven w-100"> Continue & Submit</button>}
                                        </div>
                                    </div>
                                </form>
                                :
                                <form className="submitrequest" onSubmit={(event) => { event.preventDefault(); SendRequestOTP() }}>
                                    <div className="row controls">
                                        <div class="col-md-6 col-6 mb-2">
                                            <div className="input-group-meta form-group mb-1">
                                                <label>First Name <span class="text-danger">*</span></label>
                                                <input name="firstName" type="text" class="form-control" placeholder="Enter First Name" id="name" data-type="alphawithspace" maxLength="50" value={data.firstName} onInput={ChangeInput} required />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 mb-2">
                                            <div className="input-group-meta form-group mb-1">
                                                <label>Last Name<span class="text-danger">*</span></label>
                                                <input name="lastName" type="text" class="form-control" placeholder="Enter Last Name" id="name" data-type="alphawithspace" maxLength="50" value={data.lastName} onInput={ChangeInput} required />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-6 mb-2">
                                            <div className="input-group-meta form-group mb-1">
                                                <label>Email address <span class="text-danger">*</span></label>
                                                <input name="email" type="email" class="form-control" placeholder="enter email address" id="email" data-type="alphanumericwithsymble" maxLength="60" value={data.email} onInput={ChangeInput} required />
                                            </div>
                                        </div>
                                       <div class="col-md-6 col-6 mb-2">
                                            <div className="input-group-meta form-group mb-1"><label>Phone <span class="text-danger">*</span></label>


                                                <div className="input-group contactvalid">


                                                    <button class=" input-group-text dropdown-toggle " type="button" data-bs-toggle="dropdown" aria-expanded="false">{data?.countryCode || 'Code'}</button>

                                                    <ul class="dropdown-menu country-filter">

                                                        <li style={{ cursor: "pointer" }} className="search-menu" >

                                                            <span class="dropdown-item"> <i class="bi bi-search icon-search"></i>
                                                                <input data-type="name" className="form-control form-control-sm search-bar" name="searchCountry" placeholder="Search Country" value={data.searchCountry} onInput={ChangeInput} /></span>
                                                        </li>
                                                        {(countrys || []).map((cty) => { return (<li onClick={() => { setData((prev) => ({ ...prev, searchCountry: '', countryCode: cty.code, country: cty.name })) }}><span class="dropdown-item">{cty.name}</span></li>) })}
                                                    </ul>

                                                    <input data-type="mobile" class="form-control" name="mobile" id="monile" type="text" placeholder="enter mobile no" value={data.mobile} onInput={ChangeInput} required />


                                                </div>


                                            </div>
                                        </div>

                                        <div class="col-md-6 col-6 mb-35">
                                            <div className="input-group-meta form-group mb-1">
                                                <label>Organisation Name<span class="text-danger">*</span></label>
                                                <input name="organization" type="text" class="form-control" placeholder="Enter Organisation Name" data-type="alphawithspace" maxLength="60" value={data.organization} onInput={ChangeInput} required />
                                            </div>
                                        </div>
                                        <div className=" col-md-6 col-6 mb-35">
                                            <div className="input-group-meta form-group mb-1">
                                                <label>Industries*</label>
                                                <select name="industryID" data-error="Valid Category is required." value={data.industryID} id="subject" onChange={ChangeInput} required>
                                                    <option value="">-- Select Industries --</option>
                                                    {industries.map((inty) => (<option value={inty.industryID}>{inty.name}</option>))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            {request.otpLoader ? <button type="button" className="theme-btn-seven w-100" disabled><div class="spinner-border" role="status" style={{ width: "17px", height: "17px" }}></div></button> : <button type="submit" className="theme-btn-seven w-100"> Request Now</button>}
                                        </div>
                                    </div>
                                </form>
                        }

                    </div>
                </main>
            </div>
        </div>
    </>)
}